import { ModifierFunction } from './base'

const transform = (() => {
}) as unknown as ModifierFunction<any, any, 'transform'>

transform._defaults = {}

export default transform
